export function updateArray(
    immutableobjectArray,
    itemSelector,
    updateFunc,
    insertIfNotFound = false
) {
    let itemIndex = -1;
    if (typeof itemSelector === 'function') {
        itemIndex = immutableobjectArray.findIndex(itemSelector);
    } else if (typeof itemSelector === 'number') {
        itemIndex = itemSelector;
    }
    if (itemIndex < 0) {
        if (insertIfNotFound) {
            return [...immutableobjectArray, updateFunc()];
        }
        return immutableobjectArray;
    }
    return [
        ...immutableobjectArray.slice(0, itemIndex),
        updateFunc(immutableobjectArray[itemIndex]),
        ...immutableobjectArray.slice(itemIndex + 1),
    ];
}

export function deleteArrayItemAtIndex(array, itemIndex) {
    if (itemIndex < 0) {
        throw new Error('Array item not found');
    }
    return [...array.slice(0, itemIndex), ...array.slice(itemIndex + 1)];
}

export function removeFromObject(immutableObject, key) {
    const { [key]: removeItem, ...newState } = immutableObject;
    return newState;
}

export function filterObject(immutableObject, compareFunc) {
    return Object.entries(immutableObject).reduce((prev, [key, value]) => {
        if (compareFunc(value, key)) {
            return { ...prev, [key]: value };
        }
        return prev;
    }, {});
}

export function updateEachObjectValue(immutableObject, updateFunc) {
    return Object.entries(immutableObject).reduce((prev, [key, value]) => {
        return { ...prev, [key]: updateFunc(value, key) };
    }, {});
}

function updateObjectByPathArray(immutableObject, path, updateFunc) {
    if (path.length) {
        const [curParameterKey, ...restPath] = path;
        return {
            ...immutableObject,
            [curParameterKey]: updateObjectByPathArray(
                immutableObject[curParameterKey],
                restPath,
                updateFunc
            ),
        };
    }
    return updateFunc(immutableObject);
}

export function updateObjectByPath(immutableObject, path, updateFunc) {
    return updateObjectByPathArray(
        immutableObject,
        path.split('.'),
        updateFunc
    );
}
